module.exports = __webpack_public_path__ + "media/images/app/visitors/testimonials/hero_mobile-031dab8aa3260e9a6930235be613f838.webp";